/* eslint-disable no-restricted-globals */

import '../css/main.css';

import './modules/sharer.js';

import lazyLoadModule from './utils/loaders/moduleLoader.js';

lazyLoadModule('alpineComponents', 100);

lazyLoadModule('masonry', 100);

const lazySelector = 'img[loading="lazy"], iframe[loading="lazy"], source[data-srcset]';
const lazyImageEls = document.querySelectorAll(lazySelector);

if (lazyImageEls.length > 0 && 'loading' in HTMLImageElement.prototype) {
  lazyLoadModule('lazysizes', 100, { els: lazyImageEls, selector: lazySelector });
}

if (import.meta.hot) {
  import.meta.hot.accept();
}
